export const getLatLng = (inputAddress: string) => {
  const geocoder = new window.google.maps.Geocoder()
  return new Promise((resolve, reject) => {
    geocoder.geocode(
      {
        address: inputAddress,
      },
      (results: any, status: any) => {
        console.log(status)
        if (status !== 'OK') reject(status)
        resolve({
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        })
      }
    )
  })
}

export const getDistance = (
  from: { [key: string]: number },
  to: { [key: string]: number }
) => {
  const origin = new window.google.maps.LatLng(from.lat, from.lng)
  const destination = new window.google.maps.LatLng(to.lat, to.lng)
  const directionsService = new window.google.maps.DirectionsService()
  // const directionsRenderer = new window.google.maps.DirectionsRenderer()
  return new Promise((resolve, reject) => {
    directionsService.route(
      {
        origin: origin, // 出発地 事業所のlatlng
        destination: destination, // 到着地 latalng
        avoidHighways: true, // 高速は利用しない
        travelMode: 'DRIVING', // 車モード
        drivingOptions: {
          departureTime: new Date(),
          trafficModel: window.google.maps.TrafficModel.BEST_GUESS,
        },
      },
      (response: any, status: any) => {
        console.log(response)
        if (status !== 'OK') reject(status)
        resolve(response.routes[0].legs[0].distance)
        // console.log(response)
        // const legs = response.routes[0].legs[0].distance.value
        // return legs
      }
    )
  })
}
